<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="category/getCategories"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Category')"
            variant="primary"
            :to="{ name: 'categories-create'}"
          >
            Buat Kategori
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="categories2.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Nama -->
        <template #cell(name)="data">
          <b-media
            vertical-align="center"
          >
            <template #aside>
              <b-img
                rounded
                width="50"
                :src="linkStaging(data.item.image_url, 50, 50)"
                alt=""
              />
            </template>
            <span class="font-weight-bold d-block">
              {{ data.item.name }}
            </span>
            <b-badge
              v-if="data.item.order"
              variant="light-primary"
            >
              #{{ data.item.order }}
            </b-badge>
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="categories2.meta"
          action="category/getCategories"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'Category')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Kategori ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BCard,
  BButton,
  BBadge,
  BTable,
  BImg,
  BSpinner,
  BMedia,
} from 'bootstrap-vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BSkeletonTable,
    BCard,
    BBadge,
    BButton,
    BTable,
    BImg,
    BSpinner,
    BMedia,
    TableHeader,
    TableAction,
    Pagination,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'parent', label: 'Parent' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      deletedData: '',
      isDeleting: false,
    }
  },
  computed: {
    ...mapState('category', ['categories2', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: this.canAccess('read', 'Product') || this.canAccess('manage', 'Product'),
          to: 'products|category_id:id',
          action: '',
          icon: 'EyeIcon',
          title: 'Lihat Produk',
        },
        {
          access: this.canAccess('manage', 'Category'),
          to: 'categories-edit|id:id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: this.canAccess('manage', 'Category'),
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getCategories(this.query)
  },
  methods: {
    ...mapActions('category', ['getCategories', 'deleteCategory']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteCategory({ categoryId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>
